const groupByRow = (cells) => {
  const collection = cells.reduce((changes, change) => {
    const row = changes[change.position] ?? {
      rowIndex: change.rowIndex,
      position: change.position,
      id: change.ghost ? void 0 : change.id,
      patch: []
    };
    const patch = {
      rowIndex: row.rowIndex,
      position: row.position,
      id: row.id,
      column: change.column,
      columnKey: change.columnKey,
      value: change.value
    };
    row.patch.push(patch);
    changes[change.position] = row;
    return changes;
  }, {});
  return Object.values(collection);
};
export {
  groupByRow
};
